import {
    Filter_FilterWordText,
    Filter_FilterExcelText,
    Filter_FilterPDFText,
    Filter_FilterPowerPointText,
    Filter_FilterAllText,
} from './FilePickerFilterView.locstring.json';
import loc from 'owa-localize';
import { observer } from 'mobx-react';
import { DirectionalHint } from 'office-ui-fabric-react/lib/common/DirectionalHint';
import { ContextualMenu } from 'office-ui-fabric-react/lib/ContextualMenu';
import { IContextualMenuItem } from 'office-ui-fabric-react/lib/ContextualMenu';
import AttachmentItemsFilterBy from 'owa-service/lib/contract/AttachmentItemsFilterBy';
import * as React from 'react';

import { ControlIcons } from 'owa-control-icons';

export interface FilePickerFilterProps {
    filterOptions: AttachmentItemsFilterBy[];
    selectedFilterOption: AttachmentItemsFilterBy;
    getTargetElement: HTMLElement;
    onFilterOptionClicked: (selectedFilter: AttachmentItemsFilterBy) => void;
    onFilterMenuDismissed: () => void;
}

// This component is responsible for showing filter menu options in the File Picker.
@observer
export default class FilePickerFilterView extends React.Component<FilePickerFilterProps, {}> {
    render() {
        return (
            <ContextualMenu
                shouldFocusOnMount={true}
                directionalHint={DirectionalHint.bottomRightEdge}
                target={this.props.getTargetElement}
                onDismiss={this.props.onFilterMenuDismissed}
                items={this.getFilterOptionsItems()}
            />
        );
    }

    private getFilterOptionsItems = (): IContextualMenuItem[] => {
        return this.props.filterOptions.map(filterOption =>
            this.createFilterOptionItem(filterOption)
        );
    };

    private createFilterOptionItem(filterBy: AttachmentItemsFilterBy): IContextualMenuItem {
        switch (filterBy) {
            case AttachmentItemsFilterBy.WordFiles:
                return this.getItem(filterBy, loc(Filter_FilterWordText));
            case AttachmentItemsFilterBy.ExcelFiles:
                return this.getItem(filterBy, loc(Filter_FilterExcelText));
            case AttachmentItemsFilterBy.PDFFiles:
                return this.getItem(filterBy, loc(Filter_FilterPDFText));
            case AttachmentItemsFilterBy.PowerPointFiles:
                return this.getItem(filterBy, loc(Filter_FilterPowerPointText));
            case AttachmentItemsFilterBy.None:
                return this.getItem(filterBy, loc(Filter_FilterAllText));
            default:
                throw new Error(
                    'This AttachmentItemsFilterBy type is not being correctly handled in the createFilterOptionItem() method:' +
                        filterBy
                );
        }
    }

    private getItem(filterItem: AttachmentItemsFilterBy, filterName: string): IContextualMenuItem {
        return {
            key: filterItem.toString(),
            icon: this.props.selectedFilterOption === filterItem ? ControlIcons.Accept : '',
            name: filterName,
            onClick: () => {
                this.props.onFilterOptionClicked(filterItem);
            },
        };
    }
}
